"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var region_select_1 = require("../addresses/region_select");
var graphql_tag_1 = require("graphql-tag");
var lodash_1 = require("lodash");
var form_group_with_select_1 = require("@reverbdotcom/commons/dist/components/form_group_with_select");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var form_group_with_checkbox_1 = require("@reverbdotcom/commons/dist/components/form_group_with_checkbox");
var DEFAULT_COUNTRY_CODE = 'US';
var CALCULATION_TYPES = {
    auto: 'auto',
    custom: 'custom',
};
var myShopTaxPolicyData = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query MyShopTaxPolicyData\n    {\n      me {\n        shop {\n          address {\n            countryCode\n          }\n        }\n      }\n      countries {\n        countries {\n          name\n          countryCode\n          subregions {\n            name\n            code\n          }\n        }\n      }\n    }\n  "], ["\n    query MyShopTaxPolicyData\n    {\n      me {\n        shop {\n          address {\n            countryCode\n          }\n        }\n      }\n      countries {\n        countries {\n          name\n          countryCode\n          subregions {\n            name\n            code\n          }\n        }\n      }\n    }\n  "]))));
function countries(props) {
    return lodash_1.get(props, 'data.countries.countries', []);
}
function myShopCountryCode(props) {
    return lodash_1.get(props, 'data.me.shop.address.countryCode', DEFAULT_COUNTRY_CODE);
}
function TaxRegionSelect(props) {
    return (React.createElement("div", { className: "g-col-5 g-col-mobile-12" },
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", { htmlFor: "tax_policy[region]" }, I18n.t('discovery.taxPoliciesForm.state'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement(region_select_1.default, { name: "tax_policy[region]", countryCode: myShopCountryCode(props.taxPolicyProps), countries: countries(props.taxPolicyProps), value: props.region, onChange: function (event) { return props.setRegion(event.target.value); } })))));
}
function calculationTypeOptions() {
    return Object.keys(CALCULATION_TYPES).map(function (key) {
        return {
            text: I18n.t("discovery.taxPoliciesForm.calculationTypes." + CALCULATION_TYPES[key]),
            value: CALCULATION_TYPES[key],
        };
    });
}
function CalculationTypeSelect(props) {
    var inputName = 'tax_policy[calculation_type]';
    return (React.createElement("div", { className: "g-col-3 g-col-mobile-12" },
        React.createElement(form_group_with_select_1.default, { label: I18n.t('discovery.taxPoliciesForm.taxRate'), inputName: inputName, options: calculationTypeOptions(), updateField: function (field) { props.setCalculationType(field[inputName]); } })));
}
function RateInput() {
    return (React.createElement("div", { className: "g-col-4 g-col-mobile-12" },
        React.createElement(form_group_with_input_1.default, { inputName: "tax_policy[rate]", label: I18n.t('discovery.taxPoliciesForm.rate'), currencySuffix: "%", numberOnly: true })));
}
function ApplyTaxCheckbox() {
    return (React.createElement("div", { className: "g-col-12" },
        React.createElement(form_group_with_checkbox_1.default, { inputName: "tax_policy[include_shipping]", label: I18n.t('discovery.taxPoliciesForm.includeShipping') })));
}
function Placeholder() {
    return (React.createElement("div", { className: "mb-2" },
        React.createElement("div", { className: "tax-policy-form tax-policy-form--placeholder" })));
}
function TaxPolicyUS(props) {
    var _a = React.useState(''), region = _a[0], setRegion = _a[1];
    var _b = React.useState(CALCULATION_TYPES.auto), calculationType = _b[0], setCalculationType = _b[1];
    if (props.data.loading) {
        return React.createElement(Placeholder, null);
    }
    return (React.createElement("div", { className: "g-container mb-1" },
        React.createElement(TaxRegionSelect, { taxPolicyProps: props, region: region, setRegion: setRegion }),
        region.length > 0 && React.createElement(CalculationTypeSelect, { setCalculationType: setCalculationType }),
        calculationType === CALCULATION_TYPES.custom && React.createElement(RateInput, null),
        calculationType === CALCULATION_TYPES.custom && React.createElement(ApplyTaxCheckbox, null),
        React.createElement("input", { type: "hidden", name: "tax_policy[greater_region_code]", value: myShopCountryCode(props) })));
}
exports.TaxPolicyUS = TaxPolicyUS;
exports.default = react_apollo_1.compose(myShopTaxPolicyData)(TaxPolicyUS);
var templateObject_1;
//# sourceMappingURL=tax_policy_us.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/dashboard/tax_policy_us.js
// module id = 0aJb
// module chunks = 20 21